var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgniteWhiteRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "103.8px",
    height: "140.8px",
    viewBox: "0 0 103.8 140.8",
    style: {
      enableBackground: "new 0 0 103.8 140.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDB00;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "diamond_2_",
    className: "st0",
    points: "72.9,109.1 51.9,88.4 30.9,109.1 51.9,129.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,124.5L86.2,46.5c-0.2-1-0.5-1.5-0.5-1.5L55.7,4c-0.9-1.2-2.3-2-3.9-2c0,0,0,0,0,0c-1.5,0-3,0.7-3.9,2 L18.1,45c0,0-0.4,0.5-0.5,1.5L5.5,124.5c-0.3,2.1,0.7,4.1,2.6,5c1.8,0.9,4.1,0.6,5.6-0.9l13.1-13.1l22,22.1c0.9,0.9,2,1.3,3.2,1.3 c0,0,0,0,0,0c1.2,0,2.4-0.5,3.2-1.3l22-22.1l13.1,13.1c0.9,0.9,2.1,1.4,3.4,1.4c0,0,0,0,0,0c0.8,0,1.5-0.2,2.2-0.5 c0.5-0.2,0.9-0.5,1.2-0.9C98,127.5,98.5,126,98.3,124.5z M51.9,14.9L72,42.5l-40.3,0L51.9,14.9z M71.3,52.1L51.9,75.7L32.5,52.1 L71.3,52.1z M17.2,111.4l8.2-52.9L45.5,83L17.2,111.4z M51.9,127.9l-18.8-18.8l18.8-18.9l18.8,18.8L51.9,127.9z M58.3,83 l20.1-24.5l8.2,52.8L58.3,83z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgniteWhiteRocket);
export default __webpack_public_path__ + "static/media/Ignite-White-Rocket.3603d13340ccead653573aeb67fb9b05.svg";
export { ForwardRef as ReactComponent };